const SvgComponent = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width={338} height={254}>
    <title>{"lifebelt"}</title>
    <defs>
      <linearGradient id="a" x1="50%" x2="50%" y1="0%" y2="96.706%">
        <stop offset="7.537%" stopColor="#68B6CE" stopOpacity={0.49} />
        <stop offset="56.16%" stopColor="#8CD9F1" stopOpacity={0} />
        <stop offset="100%" stopColor="#8CD9F1" stopOpacity={0} />
      </linearGradient>
    </defs>
    <g fill="none" fillRule="evenodd">
      <path
        fill="url(#a)"
        d="M242.958 193 109.23 180.714 101 116.832s23.454-16.79 43.617-18.43c20.161-1.637 45.673-3.685 61.308 5.734 15.637 9.419 50.611 29.486 50.611 29.486s9.464 6.96 9.464 22.523c0 15.56-23.042 36.855-23.042 36.855m74.68-23.48-8.224-57.55-16.968-66.57c-16.587 3.536-76.378-43.186-146.107-36.609-69.727 6.577-70.494 55.905-70.494 55.905S29.379 97.172 19.92 100.05c-9.458 2.878-13.16 10.687-9.046 20.554 4.11 9.864-2.469 32.885-2.469 32.885s-18.914 26.309 0 40.695c18.916 14.388 13.981 30.42 13.981 30.42-.41 31.242 27.552 38.64 27.552 38.64s30.84 12.333 43.588 26.72c12.748 14.387 63.737 19.732 63.737 19.732s36.188 2.876 78.543-9.046c42.354-11.919 55.513-23.019 60.448-38.639 4.934-15.62 22.205-27.13 22.205-27.13 27.14-19.732 18.092-31.242 18.092-36.176 0-4.931-18.914-29.184-18.914-29.184Z"
      />
      <path
        fill="#ED663C"
        d="M184.7 188.1c-45.2 0-81.8-28.4-81.8-63.4s36.6-63.4 81.8-63.4c45.2 0 81.8 28.4 81.8 63.4 0 35.1-36.6 63.4-81.8 63.4M184.1.9C99.4.9 30.8 57.3 30.8 126.9s68.6 126 153.3 126c84.7 0 153.3-56.4 153.3-126S268.7.9 184.1.9"
      />
      <path
        fill="#FFF"
        d="M183.8 61.7s-3.7-45.8 14.3-60.5c0 0 28.7.6 53.7 12.8 0 0-20 32.5-18.9 59.8 0-.1-18.7-12.1-49.1-12.1m-66.4 28.4S98.9 47.2 48.7 68.6c0 0-11.8 13.8-16.9 43.5 0 0 42.1-25.4 72.3 19.1.1 0-2.8-22.7 13.3-41.1m23.4 87.5S117 206.2 120.4 242c0 0 23.4 9.9 54.3 11.4 0 0 3.7-43.2 13.5-65-.1 0-33.2-2.6-47.4-10.8m125.7-58.8c.4 1.1 2.3 18.1-8.2 34.9 0 0 45.4-12.1 67.1 24 0 0 11.5-20 12.2-47.2 0 0-30-38.5-71.1-11.7"
      />
      <path
        fill="#000"
        fillRule="nonzero"
        d="M109.3 103.2c0 .4.2-1 .2-.6 9.8-25.8 42.8-41.1 75.2-41.1 44.5 0 80.6 27.6 81.5 62 1.6-3.7.9-17.2.5-20.3-3.2-27.5-32.9-57.8-78-57.8-44.9 0-79.4 22.8-79.4 57.8ZM188.7 232c-84.6 0-153.1-56.4-153.1-125.9 0-3.2-.3-6.6 0-9.7C34 102.1 31.5 112 31 125c-2.4 69.5 68.7 128.9 153.3 128.9 80.6 0 146.7-51.2 152.7-116.3-17 54.3-77 94.4-148.3 94.4Z"
        opacity={0.295}
      />
      <path
        fill="#3A484A"
        d="M107.4 48.5c-2.1.6-4.3-.5-5-2.6l-1.7-5.6c-.6-2.1.6-4.3 2.7-4.9 2.1-.6 4.3.5 5 2.6l1.7 5.6c.6 2.1-.6 4.3-2.7 4.9ZM166.7 26.8c-2.1.6-4.3-.5-5-2.6l-1.7-5.6c-.6-2.1.6-4.3 2.7-4.9 2.1-.6 4.3.5 5 2.6l1.7 5.6c.6 2.1-.6 4.3-2.7 4.9ZM137.9 41.7c-4.1 1.2-8.4.7-11.9-1.5-1.9-1.1-2.4-3.6-1.3-5.4 1.2-1.8 3.6-2.4 5.4-1.3 1.6 1 3.6 1.2 5.5.6s3.4-1.9 4.2-3.6c.9-2 3.2-2.9 5.2-2 2 .9 2.9 3.2 2 5.2-1.8 3.9-5.1 6.8-9.1 8Z"
      />
    </g>
  </svg>
)
export { SvgComponent as LifeBelt }
